export enum ProgressBarStatus {
  NO_DISPLAY = 'noDisplay',
  READY = 'ready',
  MOVING = 'moving',
  DONE = 'done',
}
